// @flow

import React from 'react';
import styled from 'styled-components';
import InputMask from 'react-input-mask';

type Props = {
  id: string,
  label?: string,
  validationError?: boolean,
  disabled?: boolean,
};

const MaskedInputContainer = styled.div`
  display: inline-block;
  margin-bottom: 1em;
`;
const MaskedInputLabel = styled.label`
  font-size: 0.875em;
  color: ${(props) => props.theme.textColor};
  display: block;
  margin-bottom: 0.5em;
`;

const MaskedInputField = styled(InputMask)`
  border: 1px solid
    ${(props) =>
      props['aria-invalid'] === 'true'
        ? props.theme.errorColor
        : props.theme.borderColor};
  border-radius: 0.125em;
  padding: 0.75em 1.125em;
  font-size: 1em;
  color: ${(props) => props.theme.textColor};
  width: 100%;
  letter-spacing: 2px;
  font-family: monospace;

  &:focus {
    border: 1px solid ${(props) => props.theme.actionColor};
    outline: 0;
  }

  &::-webkit-input-placeholder {
    color: #7f9baa;
  }
  &::-moz-placeholder {
    opacity: 1;
    color: #7f9baa;
  }
  &:-ms-input-placeholder {
    color: #7f9baa;
  }
`;

const MaskedInput = ({
  id,
  label,
  validationError,
  disabled,
  ...props
}: Props) => {
  const attributes = {};
  if (disabled) {
    attributes['disabled'] = 'disabled';
  }
  return (
    <MaskedInputContainer>
      {label && <MaskedInputLabel htmlFor={id}>{label}</MaskedInputLabel>}
      <MaskedInputField
        id={id}
        data-autotestid={id}
        aria-invalid={validationError ? 'true' : 'false'}
        {...props}
        {...attributes}
      />
    </MaskedInputContainer>
  );
};

export default MaskedInput;
